import { getSessionUUID } from '../components/lib/AuthToken'; // Import the utility function
import logger from "../utils/logger";

export const check_route_sync_status = async () => {
    try {
        const sessionToken = await getSessionUUID();

        const requestOptions = {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionToken}`
            },
        };

        const response = await fetch('/routing/route_sync_status', requestOptions);
        const responseBody = await response.json();

        return {
            message: 'Request successful',
            status: response.status,
            data: responseBody || null,
        };
    } catch (err) {
        logger.error("Error checking route sync status:", err);
        return {
            message: err.message || 'An error occurred',
            status: 500,
        };
    }
};

export const fetch_all_routes = async (range) => {
    
    try {

        const sessionToken = await getSessionUUID(); // Use the utility function
        const body = { range };

        // Options to send data to backend
        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionToken}`
            },
            body: JSON.stringify(body),
        };

        // Send Request to backend
        const response = await fetch('/routing/get_all_routes', requestOptions);
        const responseBody = await response.json();

        // Return the message and status
        return {
            message: 'Request successful',
            status: response.status,
            data: responseBody || null, // Include data if provided
        };
    } catch (err) {
        logger.error("Error fetching routes:", err);
        return {
            message: err.message || 'An error occurred',
            status: 500,
        };
    }
};

//-------------------------------------------------------------------------------------------------
export const fetch_notes = async (range) => {
    
    try {

        const sessionToken = await getSessionUUID(); // Use the utility function
        const body = { range };

        // Options to send data to backend
        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionToken}`
            },
            body: JSON.stringify(body),
        };

        // Send Request to backend
        const response = await fetch('/routing/get_all_notes', requestOptions);
        const responseBody = await response.json();

        // Return the message and status
        return {
            message: 'Request successful',
            status: response.status,
            data: responseBody || null, // Include data if provided
        };
    } catch (err) {
        logger.error("Error fetching routes:", err);
        return {
            message: err.message || 'An error occurred',
            status: 500,
        };
    }
};

//-------------------------------------------------------------------------------------------------

export const add_notes = async (noteData) => {

    try{
        logger.log("Adding notes to system: ", noteData);
        const sessionToken = await getSessionUUID();
        // User input
        const body = {
            notes: noteData
        };

        // Options to send data to backend
        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionToken}`,
            },
            body: JSON.stringify(body),
        };

        // Send Request to backend and log any errors
        const response = await fetch('/routing/add_notes', requestOptions);
        const responseBody = await response.json();

        if (response.status === 201 || response.status === 200) {
            // Show success message with server response
            return { message: responseBody.message || 'Notes Added Successfully', status: response.status };
        } else {
            // Show error message with server response
            return { message: responseBody.error || 'Failed to create notes', status: response.status };
        }
    } catch (err) {
        logger.error("Error updating notes:", err);
        return {
            message: err.message || 'An error occurred',
            status: 500,
        };
    }
}

//-------------------------------------------------------------------------------------------------

export const delete_notes = async (noteData) => {

    try{
        logger.log("deleting notes for: ", noteData);
        const sessionToken = await getSessionUUID();
        // User input
        const body = {
            date: noteData
        };

        // Options to send data to backend
        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionToken}`,
            },
            body: JSON.stringify(body),
        };

        // Send Request to backend and log any errors
        const response = await fetch('/routing/delete_notes', requestOptions);
        const responseBody = await response.json();

        if (response.status === 201 || response.status === 200) {
            // Show success message with server response
            return { message: responseBody.message || 'Notes deleted Successfully', status: response.status };
        } else {
            // Show error message with server response
            return { message: responseBody.error || 'Failed to delete notes', status: response.status };
        }
    } catch (err) {
        logger.error("Error deleting notes:", err);
        return {
            message: err.message || 'An error occurred',
            status: 500,
        };
    }
}

//-------------------------------------------------------------------------------------------------

export const update_notes = async (noteData) => {

    try{
        logger.log("Adding notes to system: ", noteData);
        const sessionToken = await getSessionUUID();
        // User input
        const body = {
            notes: noteData
        };

        // Options to send data to backend
        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionToken}`,
            },
            body: JSON.stringify(body),
        };

        // Send Request to backend and log any errors
        const response = await fetch('/routing/update_notes', requestOptions);
        const responseBody = await response.json();

        if (response.status === 201 || response.status === 200) {
            // Show success message with server response
            return { message: responseBody.message || 'Notes Added Successfully', status: response.status };
        } else {
            // Show error message with server response
            return { message: responseBody.error || 'Failed to create notes', status: response.status };
        }
    } catch (err) {
        logger.error("Error updating notes:", err);
        return {
            message: err.message || 'An error occurred',
            status: 500,
        };
    }
}

//-------------------------------------------------------------------------------------------------

export const add_route = async (route) => {

    try{
        logger.log("Adding route to system: ", route);
        const sessionToken = await getSessionUUID();
        // User input
        const body = {
            route: route
        };

        // Options to send data to backend
        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionToken}`,
            },
            body: JSON.stringify(body),
        };

        // Send Request to backend and log any errors
        const response = await fetch('/routing/add_route', requestOptions);
        const responseBody = await response.json();

        if (response.status === 201 || response.status === 200) {
            // Show success message with server response and return data
            return { 
                message: responseBody.message || 'Route Added Successfully', 
                status: response.status,
                data: responseBody.data || null
            };
        } else {
            // Show error message with server response
            return { message: responseBody.error || 'Failed to create route', status: response.status };
        }
    } catch (err) {
        logger.error("Error updating routes:", err);
        return {
            message: err.message || 'An error occurred',
            status: 500,
        };
    }
}

//-------------------------------------------------------------------------------------------------

export const add_bulk_routes = async (jobs) => {
    try {
        const sessionToken = await getSessionUUID();
        const body = { jobs };

        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionToken}`,
            },
            body: JSON.stringify(body),
        };

        // Send Request to backend and log any errors
        const response = await fetch('/routing/add_bulk_routes', requestOptions);
        const responseBody = await response.json();

        if (response.status === 201 || response.status === 200) {
            // Show success message with server response
            return { 
                message: responseBody.message || 'Routes Added Successfully', 
                status: response.status,
                data: responseBody
            };
        } else {
            // Show error message with server response
            return { 
                message: responseBody.error || 'Failed to create routes', 
                status: response.status,
                data: responseBody
            };
        }
    } catch (err) {
        logger.error("Error adding bulk routes:", err);
        return {
            message: err.message || 'An error occurred',
            status: 500,
        };
    }
}

export const uploadNetworkFreightCsv = async (file, customerId) => {
    try {
        const sessionToken = await getSessionUUID();
        const formData = new FormData();
        formData.append('file', file);
        formData.append('customer_id', customerId);
        const response = await fetch('/routing/network-freight/upload', {
            method: 'POST',
            headers: { 'Authorization': `Bearer ${sessionToken}` },
            body: formData,
        });
        const data = await response.json();
        return { status: response.status, data };
    } catch (err) {
        logger.error('Network freight upload failed:', err);
        return { status: 500, data: { error: err.message || 'Upload failed' } };
    }
};

export const downloadNetworkFreightTemplate = async () => {
    try {
        const sessionToken = await getSessionUUID();
        const response = await fetch('/routing/network-freight/template', {
            headers: { 'Authorization': `Bearer ${sessionToken}` },
        });
        if (!response.ok) return { status: response.status };
        const blob = await response.blob();
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = 'network-freight-template.csv';
        document.body.appendChild(link);
        link.click();
        link.remove();
        URL.revokeObjectURL(url);
        return { status: response.status };
    } catch (err) {
        logger.error('Network freight template download failed:', err);
        return { status: 500 };
    }
};

export const searchNetworkFreightByConsignment = async (consignmentNumber) => {
    try {
        const sessionToken = await getSessionUUID();
        const params = new URLSearchParams({ consignment_number: consignmentNumber });
        const response = await fetch(`/routing/network-freight/search?${params.toString()}`, {
            headers: { 'Authorization': `Bearer ${sessionToken}` },
        });
        const data = await response.json();
        return { status: response.status, data };
    } catch (err) {
        logger.error('Network Freight search failed:', err);
        return { status: 500, data: { error: err.message || 'Search failed' } };
    }
};

export const getRegularDeliveriesForDate = async (date) => {
    try {
        const sessionToken = await getSessionUUID();

        const response = await fetch('/routing/get-regular-deliveries', {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${sessionToken}`,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ date }),
        });

        const responseBody = await response.json();

        if (response.status === 200) {
            return {
                message: responseBody.message || 'Regular deliveries fetched successfully',
                status: response.status,
                data: responseBody.data || responseBody || []
            };
        } else {
            return {
                message: responseBody.error || 'Failed to fetch regular deliveries',
                status: response.status,
                data: responseBody.data || []
            };
        }
    } catch (err) {
        logger.error("Error fetching regular deliveries:", err);

        return {
            message: err.message || 'An error occurred',
            status: 500,
            data: []
        };
    }
};

// Bulk create jobs with progress tracking
export const bulkCreateJobsWithProgress = async (jobsData, callbacks) => {
    return new Promise(async (resolve, reject) => {
        try {
            const sessionToken = await getSessionUUID();
            
            // Step 1: Start the background process
            const startResponse = await fetch('/routing/bulk-create-jobs-start', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${sessionToken}`
                },
                body: JSON.stringify({ jobs: jobsData })
            });

            if (!startResponse.ok) {
                const errorData = await startResponse.json();
                throw new Error(errorData.error || `HTTP error! status: ${startResponse.status}`);
            }

            const startData = await startResponse.json();
            const processUuid = startData.uuid;
            
            // Call onStart callback
            if (callbacks.onStart) {
                callbacks.onStart();
            }
            
            // Step 2: Track progress to completion
            let hasCompleted = false;
            const pollInterval = setInterval(async () => {
                if (hasCompleted) return;
                try {
                    const progressResponse = await fetch(`/routing/bulk-create-jobs-progress/${processUuid}`, {
                        method: 'GET',
                        headers: {
                            'Authorization': `Bearer ${sessionToken}`
                        }
                    });

                    if (!progressResponse.ok) {
                        // If we get a 404, the process might have completed and been cleaned up
                        if (progressResponse.status === 404) {
                            clearInterval(pollInterval);
                            if (hasCompleted) return;
                            hasCompleted = true;
                            // Only resolve as success if we have no other choice - but warn about missing route_ref
                            const finalResult = {
                                success: true,
                                message: 'Process completed but route reference data may be missing',
                                processed: jobsData.length,
                                total: jobsData.length,
                                success_count: jobsData.length,
                                error_count: 0,
                                errors: [],
                                created_jobs: [] // Empty - no route_ref data available
                            };
                            
                            if (callbacks.onComplete) {
                                callbacks.onComplete(finalResult);
                            }
                            if (callbacks.onFinally) {
                                callbacks.onFinally();
                            }
                            resolve(finalResult);
                            return;
                        }
                        
                        clearInterval(pollInterval);
                        const error = `Failed to get progress: ${progressResponse.status}`;
                        if (callbacks.onError) {
                            callbacks.onError(error);
                        }
                        reject(new Error(error));
                        return;
                    }

                    const progressData = await progressResponse.json();
                    
                    // Call progress callback
                    if (callbacks.onProgress) {
                        callbacks.onProgress({
                            processed: progressData.processed || 0,
                            total: progressData.total || 0,
                            message: progressData.message || 'Processing...',
                            success_count: progressData.success_count || 0,
                            error_count: progressData.error_count || 0,
                            errors: progressData.errors || [],
                            created_jobs: progressData.created_jobs || []
                        });
                    }

                    // Check if completed
                    if (progressData.completed) {
                        hasCompleted = true;
                        clearInterval(pollInterval);
                        
                        const finalResult = {
                            success: true,
                            message: progressData.message,
                            processed: progressData.processed,
                            total: progressData.total,
                            success_count: progressData.success_count,
                            error_count: progressData.error_count,
                            errors: progressData.errors,
                            created_jobs: progressData.created_jobs || []
                        };
                        
                        // Call completion callback
                        if (callbacks.onComplete) {
                            callbacks.onComplete(finalResult);
                        }
                        
                        // Call finally callback
                        if (callbacks.onFinally) {
                            callbacks.onFinally();
                        }
                        
                        resolve(finalResult);
                    }
                } catch (pollError) {
                    // Check if this is a 404 error, which might mean the process completed and was cleaned up
                    if (pollError.message && pollError.message.includes('404')) {
                        clearInterval(pollInterval);
                        if (hasCompleted) return;
                        hasCompleted = true;
                        // Resolve as success but note missing route_ref data
                        const finalResult = {
                            success: true,
                            message: 'Process completed but route reference data may be missing',
                            processed: jobsData.length,
                            total: jobsData.length,
                            success_count: jobsData.length,
                            error_count: 0,
                            errors: [],
                            created_jobs: [] // Empty - no route_ref data available
                        };
                        
                        if (callbacks.onComplete) {
                            callbacks.onComplete(finalResult);
                        }
                        if (callbacks.onFinally) {
                            callbacks.onFinally();
                        }
                        resolve(finalResult);
                    } else {
                        clearInterval(pollInterval);
                        if (callbacks.onError) {
                            callbacks.onError(pollError.message);
                        }
                        if (callbacks.onFinally) {
                            callbacks.onFinally();
                        }
                        reject(pollError);
                    }
                }
            }, 1000); // Poll every 1 second

            // Add timeout (60 minutes for large operations)
            setTimeout(() => {
                clearInterval(pollInterval);
                const timeoutError = new Error('Process timed out after 60 minutes');
                if (callbacks.onError) {
                    callbacks.onError(timeoutError.message);
                }
                if (callbacks.onFinally) {
                    callbacks.onFinally();
                }
                reject(timeoutError);
            }, 3600000);
            
        } catch (error) {
            if (callbacks.onError) {
                callbacks.onError(error.message);
            }
            if (callbacks.onFinally) {
                callbacks.onFinally();
            }
            reject(error);
        }
    })
};

//-------------------------------------------------------------------------------------------------
// Route optimisation
//-------------------------------------------------------------------------------------------------

export const optimiseRoute = async (stops, mode) => {
    try {
        const sessionToken = await getSessionUUID();
        const response = await fetch('/routing/optimise-route', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${sessionToken}` },
            body: JSON.stringify({ stops, mode }),
        });
        const body = await response.json();
        return { status: response.status, data: body };
    } catch (err) {
        logger.error('Error optimising route:', err);
        return { status: 500, data: { error: err.message } };
    }
};

export const applyRouteOrder = async (updates) => {
    try {
        const sessionToken = await getSessionUUID();
        const response = await fetch('/routing/apply-route-order', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${sessionToken}` },
            body: JSON.stringify({ updates }),
        });
        const body = await response.json();
        return { status: response.status, data: body };
    } catch (err) {
        logger.error('Error applying route order:', err);
        return { status: 500, data: { error: err.message } };
    }
};

//-------------------------------------------------------------------------------------------------

export const fetch_report_data = async (range) => {
    try {

        const sessionToken = await getSessionUUID(); // Assume this gets a valid session token.

        // Send request to the backend with query parameters
        const response = await fetch(`/routing/get_reports?range=${encodeURIComponent(range)}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionToken}`,
            },
        });

        const responseBody = await response.json();
        logger.log("response body: ", responseBody.error);

        return {
            message: responseBody.error || 'Request successful',
            status: response.status,
            data: responseBody || null,
        };
    } catch (err) {
        logger.error("Error fetching data: ", err);
        return {
            message: err.message || 'An error occurred',
            status: 500,
        };
    }
};

//-------------------------------------------------------------------------------------------------

export const fetch_route_report_data = async (queryData) => {
    try {
        const sessionToken = await getSessionUUID();

        const params = { mode: queryData.mode || 'legacy' };
        if (queryData.mode === 'new') {
            if (queryData.customer_id)           params.customer_id = queryData.customer_id;
            if (queryData.customer_deliveries_id) params.customer_deliveries_id = queryData.customer_deliveries_id;
        } else {
            params.customer = queryData.customer;
            if (queryData.route) params.route = queryData.route;
        }

        const response = await fetch(`/routing/get_route_reports?${new URLSearchParams(params).toString()}`, {
            method: 'GET',
            headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${sessionToken}` },
        });

        const responseBody = await response.json();
        return { message: responseBody.error || 'Request successful', status: response.status, data: responseBody || null };
    } catch (err) {
        logger.error("Error fetching data: ", err);
        return { message: err.message || 'An error occurred', status: 500 };
    }
};


//-------------------------------------------------------------------------------------------------


export const delete_route = async (uuid) => {

    try{
        logger.log("Deleting route from system: ", uuid);
        const sessionToken = await getSessionUUID();
        // User input
        const body = {
            uuid: uuid
        };

        // Options to send data to backend
        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionToken}`,
            },
            body: JSON.stringify(body),
        };

        // Send Request to backend and log any errors
        const response = await fetch('/routing/delete_route', requestOptions);
        const responseBody = await response.json();
        logger.log("response to deleting request: ", response.status);

        if (response.status === 201 || response.status === 200) {
            // Show success message with server response
            return { message: responseBody.message || 'Route deleted successfully', status: response.status };
        } else {
            // Show error message with server response
            return { message: responseBody.error || 'Failed to delete route', status: response.status };
        }
    } catch (err) {
        logger.error("Error updating routes:", err);
        return {
            message: err.message || 'An error occurred',
            status: 500,
        };
    }
}

//-------------------------------------------------------------------------------------------------

export const update_route = async (update, uuid) => {

    try{
        logger.log("sending updated route to system");
        const sessionToken = await getSessionUUID();
        // User input
        const body = {
            update: update,
            uuid: uuid
        };

        // Options to send data to backend
        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionToken}`,
            },
            body: JSON.stringify(body),
        };

        // Send Request to backend and log any errors
        const response = await fetch('/routing/update_route', requestOptions);
        const responseBody = await response.json();

        if (response.status === 201 || response.status === 200) {
            // Show success message with server response
            return { 
                message: responseBody.message || 'Route Updated Successfully', 
                status: response.status,
                updated_at: responseBody.updated_at || null
            };
        } else {
            // Show error message with server response
            return { 
                message: responseBody.error || 'Failed to update route', 
                status: response.status,
                updated_at: null
            };
        }
    } catch (err) {
        logger.error("Error updating routes:", err);
        return {
            message: err.message || 'An error occurred',
            status: 500,
        };
    }
}

//-------------------------------------------------------------------------------------------------

export const downloadRoute = async (route) => {
    try {
        logger.log("Sending route to backend...");

        const body = JSON.stringify({ route });

        const sessionToken = await getSessionUUID();

        const response = await fetch('/routing/download_route', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionToken}`,
            },
            body,
        });

        if (!response.ok) {
            throw new Error(`Failed to download route: ${response.status} ${response.statusText}`);
        }

        // Ensure the response is a CSV file
        const contentType = response.headers.get("Content-Type");
        if (!contentType || !contentType.includes("csv")) {
            throw new Error(`Expected a CSV file, but got: ${contentType}`);
        }

        // Get file as a Blob
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);

        // Create a temporary download link
        const a = document.createElement("a");
        a.href = url;

        // Extract filename from headers with improved regex
        const contentDisposition = response.headers.get("Content-Disposition");
        let filename = `route-${Date.now()}.csv`; // Default filename with timestamp

        if (contentDisposition) {
            // Improved regex to handle different encodings and formats in the filename
            const match = contentDisposition.match(/filename\*?=["']?([^;"']+)\*?/);
            if (match) {
                // Decode and sanitize the filename
                filename = decodeURIComponent(match[1]).replace(/["']/g, '');
            }
        }

        a.download = filename;
        document.body.appendChild(a);
        a.click();

        // Cleanup
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);

        return { message: "Route downloaded successfully!", status: 200 };
    } catch (err) {
        logger.error("Error downloading route:", err);
        return {
            message: err.message || 'An error occurred',
            status: 500,
        };
    }
};

//-------------------------------------------------------------------------------------------------

export const fetch_driver_routes_data = async (driverRouteData) => {
    try {
        const sessionToken = await getSessionUUID();

        const queryParams = new URLSearchParams({
            driverId: driverRouteData.selectedValue,
            startDate: driverRouteData.startDate,
            endDate: driverRouteData.endDate,
        });

        const response = await fetch(`/routing/get_driver_routes?${queryParams.toString()}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionToken}`,
            },
        });

        const responseBody = await response.json();

        return {
            message: responseBody.error || 'Request successful',
            status: response.status,
            data: responseBody || null,
        };
    } catch (err) {
        logger.error("Error fetching driver routes data: ", err);
        return {
            message: err.message || 'An error occurred',
            status: 500,
        };
    }
};

//-------------------------------------------------------------------------------------------------

export const fetch_fire_register_report_data = async (weekData) => {
    try {
        const sessionToken = await getSessionUUID();

        const queryParams = new URLSearchParams({
            startDate: weekData.startDate,
            endDate: weekData.endDate,
        });

        const response = await fetch(`/routing/get_fire_register_report?${queryParams.toString()}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionToken}`,
            },
        });

        const responseBody = await response.json();

        return {
            message: responseBody.error || 'Request successful',
            status: response.status,
            data: responseBody || null,
        };
    } catch (err) {
        logger.error("Error fetching fire register report data: ", err);
        return {
            message: err.message || 'An error occurred',
            status: 500,
        };
    }
};

//-------------------------------------------------------------------------------------------------

export const fetch_weekly_storage_report = async (weekData) => {
    try {
        const sessionToken = await getSessionUUID();

        const queryParams = new URLSearchParams({
            week_ending: weekData.week_ending,
        });

        const response = await fetch(`/warehouse/weekly_storage_report?${queryParams.toString()}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionToken}`,
            },
        });

        const responseBody = await response.json();

        return {
            message: responseBody.error || 'Request successful',
            status: response.status,
            data: responseBody.data || null,
        };
    } catch (err) {
        logger.error("Error fetching weekly storage report data: ", err);
        return {
            message: err.message || 'An error occurred',
            status: 500,
        };
    }
};

//-----------------------------------------------------------------------------------------------------------

export const unSubcontract = async (uuid, updated_at) => {

    try{
        logger.log("unSubcontracting route:", uuid);
        const sessionToken = await getSessionUUID();
        // User input
        const body = {
            uuid: uuid,
            updated_at: updated_at
        };

        // Options to send data to backend
        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionToken}`,
            },
            body: JSON.stringify(body),
        };

        // Send Request to backend and log any errors
        const response = await fetch('/routing/unsub_route', requestOptions);
        const responseBody = await response.json();
        logger.log("response to unsubcontract request: ", response.status);

        if (response.status === 201 || response.status === 200) {
            // Show success message with server response
            return { message: responseBody.message || 'Route unsubcontracted successfully', status: response.status };
        } else {
            // Show error message with server response
            return { message: responseBody.error || 'Failed to unsubcontract route', status: response.status };
        }
    } catch (err) {
        logger.error("Error updating routes:", err);
        return {
            message: err.message || 'An error occurred',
            status: 500,
        };
    }
}

//-----------------------------------------------------------------------------------------------------------

export const subcontractRoute = async (uuid, data, updated_at) => {

    try{
        logger.log("subcontracting route:", uuid);
        const sessionToken = await getSessionUUID();
        // User input
        const body = {
            uuid: uuid,
            company: data.company,
            price: data.price,
            ref: data.ref,
            isMTW: data.isMTW || false,
            updated_at: updated_at
        };

        // Options to send data to backend
        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionToken}`,
            },
            body: JSON.stringify(body),
        };

        // Send Request to backend and log any errors
        const response = await fetch('/routing/sub_route', requestOptions);
        const responseBody = await response.json();
        logger.log("response to subcontract request: ", response.status);

        if (response.status === 201 || response.status === 200) {
            // Show success message with server response
            return { message: responseBody.message || 'Route subcontracted successfully', status: response.status };
        } else {
            // Show error message with server response
            return { message: responseBody.error || 'Failed to subcontract route', status: response.status };
        }
    } catch (err) {
        logger.error("Error updating routes:", err);
        return {
            message: err.message || 'An error occurred',
            status: 500,
        };
    }
}

//-----------------------------------------------------------------------------------------------------------

export const updateDemurrage = async (uuid, demurrageData, updated_at) => {

    try{
        logger.log("updating route demurrage:", uuid, demurrageData);
        const sessionToken = await getSessionUUID();
        // User input
        const body = {
            uuid: uuid,
            demurrage: demurrageData.demurrage,
            demurrage_reason: demurrageData.demurrage_reason,
            demurrage_cost: demurrageData.demurrage_cost,
            updated_at: updated_at
        };

        // Options to send data to backend
        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionToken}`,
            },
            body: JSON.stringify(body),
        };

        // Send Request to backend and log any errors
        const response = await fetch('/routing/update_demurrage', requestOptions);
        const responseBody = await response.json();
        logger.log("response to demurrage update request: ", response.status);

        if (response.status === 201 || response.status === 200) {
            // Show success message with server response
            return { 
                message: responseBody.message || 'Demurrage updated successfully', 
                status: response.status,
                updated_at: responseBody.updated_at || null
            };
        } else {
            // Show error message with server response
            return { 
                message: responseBody.error || 'Failed to update demurrage', 
                status: response.status,
                updated_at: null
            };
        }
    } catch (err) {
        logger.error("Error updating demurrage:", err);
        return {
            message: err.message || 'An error occurred',
            status: 500,
        };
    }
}

// Update start time for a route
export const updateStartTime = async (route_uuid, start_time) => {
    try {
        const sessionToken = await getSessionUUID();

        // Create request body
        const body = {
            route_uuid,
            start_time
        };

        // Options to send data to backend
        const requestOptions = {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionToken}`
            },
            body: JSON.stringify({ start_time }),
            credentials: 'include', // Include cookies for authentication
        };

        // Send Request to backend and log any errors
        const response = await fetch(`/routing/update_start_time/${route_uuid}`, requestOptions);
        const responseBody = await response.json();
        logger.log("response to start time update request: ", response.status);

        if (response.status === 201 || response.status === 200) {
            // Show success message with server response
            return { 
                message: responseBody.message || 'Start time updated successfully', 
                status: response.status,
                updated_at: responseBody.updated_at || null
            };
        } else {
            logger.error("Error updating start time: ", responseBody);
            return {
                message: responseBody.error || `Error ${response.status}: Failed to update start time`,
                status: response.status,
            };
        }
    } catch (err) {
        logger.error("Error updating start time:", err);
        return {
            message: err.message || 'An error occurred',
            status: 500,
        };
    }
}

//-----------------------------------------------------------------------------------------------------------

// Generate job note PDF for selected routes
export const generateJobNote = async (routes) => {
    try {
        const sessionToken = await getSessionUUID();
        
        logger.log("Generating job note for routes:", routes);

        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionToken}`
            },
            body: JSON.stringify({ routes }),
        };

        const response = await fetch('/routing/generate-job-note', requestOptions);

        if (!response.ok) {
            const errorBody = await response.json();
            throw new Error(errorBody.error || `Failed to generate job note: ${response.status} ${response.statusText}`);
        }

        // Get file as a Blob
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);

        // Create a temporary download link
        const a = document.createElement("a");
        a.href = url;

        // Extract filename from headers or create default
        const contentDisposition = response.headers.get("Content-Disposition");
        let filename = `JobNote-${Date.now()}.pdf`; // Default filename with timestamp

        if (contentDisposition) {
            const match = contentDisposition.match(/filename\*?=["']?([^;"']+)\*?/);
            if (match) {
                filename = decodeURIComponent(match[1]).replace(/["']/g, '');
            }
        }

        a.download = filename;
        document.body.appendChild(a);
        a.click();

        // Cleanup
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);

        return { message: "Job note generated successfully!", status: 200 };
    } catch (err) {
        logger.error("Error generating job note:", err);
        return {
            message: err.message || 'An error occurred while generating job note',
            status: 500,
        };
    }
}

export const fetchSubcontractedRoutes = async (fromDate, toDate) => {
    try {
        const sessionToken = await getSessionUUID();
        const body = { 
            from_date: fromDate,
            to_date: toDate
        };

        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionToken}`
            },
            body: JSON.stringify(body),
        };

        const response = await fetch('/routing/get_subcontracted_routes', requestOptions);
        const responseBody = await response.json();

        return {
            message: responseBody.success ? 'Subcontracted routes fetched successfully' : 'Failed to fetch subcontracted routes',
            status: response.status,
            data: responseBody.data || [],
        };
    } catch (err) {
        logger.error("Error fetching subcontracted routes:", err);
        return {
            message: err.message || 'An error occurred while fetching subcontracted routes',
            status: 500,
            data: [],
        };
    }
}

//-------------------------------------------------------------------------------------------------
// Customer Portal API — GDPR-strict, customer_id resolved server-side
//-------------------------------------------------------------------------------------------------

export const fetch_customer_routes = async (range) => {
    try {
        const sessionToken = await getSessionUUID();
        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionToken}`,
            },
            body: JSON.stringify({ range }),
        };
        const response = await fetch('/routing/customer_routes', requestOptions);
        const responseBody = await response.json();
        return {
            message: 'Request successful',
            status: response.status,
            data: responseBody || null,
        };
    } catch (err) {
        logger.error("Error fetching customer routes:", err);
        return { message: err.message || 'An error occurred', status: 500 };
    }
};

export const fetch_customer_routes_report = async (start_date, end_date, customer_deliveries_id = null) => {
    try {
        const sessionToken = await getSessionUUID();
        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionToken}`,
            },
            body: JSON.stringify({ start_date, end_date, customer_deliveries_id }),
        };
        const response = await fetch('/routing/customer_routes_report', requestOptions);
        const responseBody = await response.json();
        return {
            message: 'Request successful',
            status: response.status,
            data: responseBody || null,
        };
    } catch (err) {
        logger.error("Error fetching customer routes report:", err);
        return { message: err.message || 'An error occurred', status: 500 };
    }
};

export const fetch_my_deliveries = async () => {
    try {
        const sessionToken = await getSessionUUID();
        const response = await fetch('/routing/my_deliveries', {
            method: 'GET',
            headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${sessionToken}` },
        });
        const responseBody = await response.json();
        return { status: response.status, data: responseBody || null };
    } catch (err) {
        logger.error("Error fetching my deliveries:", err);
        return { status: 500, data: null };
    }
};

export const fetch_customer_requests = async () => {
    try {
        const sessionToken = await getSessionUUID();
        const response = await fetch('/routing/customer_requests', {
            method: 'GET',
            headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + sessionToken },
        });
        const responseBody = await response.json();
        return {
            status: response.status,
            data: response.ok ? responseBody.data : null,
            error: response.ok ? null : (responseBody.error || 'Failed to load route requests'),
        };
    } catch (err) {
        logger.error('Error fetching customer route requests:', err);
        return { status: 500, data: null, error: err.message || 'An error occurred' };
    }
};

export const create_customer_request = async (requestData) => {
    try {
        const sessionToken = await getSessionUUID();
        const response = await fetch('/routing/customer_requests', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + sessionToken },
            body: JSON.stringify(requestData),
        });
        const responseBody = await response.json();
        return {
            status: response.status,
            data: response.ok ? responseBody.data : null,
            error: response.ok ? null : (responseBody.error || 'Failed to submit route request'),
        };
    } catch (err) {
        logger.error('Error creating customer route request:', err);
        return { status: 500, data: null, error: err.message || 'An error occurred' };
    }
};

export const cancel_customer_request = async (requestId) => {
    try {
        const sessionToken = await getSessionUUID();
        const response = await fetch(`/routing/customer_requests/${requestId}/cancel`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + sessionToken },
        });
        const responseBody = await response.json();
        return {
            status: response.status,
            data: response.ok ? responseBody.data : null,
            error: response.ok ? null : (responseBody.error || 'Failed to cancel route request'),
        };
    } catch (err) {
        logger.error('Error cancelling customer route request:', err);
        return { status: 500, data: null, error: err.message || 'An error occurred' };
    }
};

export const fetch_customer_tracking = async (start_date, end_date, consignment_number) => {
    try {
        const sessionToken = await getSessionUUID();
        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionToken}`,
            },
            body: JSON.stringify({ start_date, end_date, consignment_number }),
        };
        const response = await fetch('/routing/customer_tracking', requestOptions);
        const responseBody = await response.json();
        return {
            message: 'Request successful',
            status: response.status,
            data: responseBody || null,
        };
    } catch (err) {
        logger.error("Error fetching customer tracking:", err);
        return { message: err.message || 'An error occurred', status: 500 };
    }
};

export const fetch_customer_consignment_media = async (consignment_number) => {
    try {
        const sessionToken = await getSessionUUID();
        const response = await fetch(`/routing/customer_consignment_media/${encodeURIComponent(consignment_number)}`, {
            method: 'GET',
            headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${sessionToken}` },
        });
        const responseBody = await response.json();
        return { status: response.status, data: responseBody || null };
    } catch (err) {
        logger.error("Error fetching customer consignment media:", err);
        return { status: 500, data: null };
    }
};

export const check_customer_warehouse_access = async () => {
    try {
        const session_uuid = getSessionUUID();
        const requestOptions = {
            method: 'GET',
            headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${session_uuid}` },
        };
        const response = await fetch('/routing/customer_warehouse_access', requestOptions);
        const data = await response.json();
        return { status: response.status, has_access: data.has_access === true };
    } catch (err) {
        logger.error("Error checking customer warehouse access:", err);
        return { status: 500, has_access: false };
    }
};

//-------------------------------------------------------------------------------------------------
// Drop-order API calls
//-------------------------------------------------------------------------------------------------

/**
 * Get the next available drop_number for a driver on a given date.
 * @param {string} profile_id
 * @param {string} date  YYYY-MM-DD
 */
export const get_next_drop_number = async (profile_id, date) => {
    try {
        const sessionToken = await getSessionUUID();
        const response = await fetch(
            `/routing/next_drop_number?profile_id=${encodeURIComponent(profile_id)}&date=${encodeURIComponent(date)}`,
            { method: 'GET', headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${sessionToken}` } }
        );
        const body = await response.json();
        return { status: response.status, drop_number: body.drop_number ?? 1 };
    } catch (err) {
        logger.error("Error getting next drop number:", err);
        return { status: 500, drop_number: 1 };
    }
};

/**
 * Batch-update drop_number (and optionally profile_id) for a list of routes.
 * @param {Array<{route_uuid: string, drop_number: number, profile_id?: string}>} reorderList
 */
export const reorder_drops = async (reorderList) => {
    try {
        const sessionToken = await getSessionUUID();
        const response = await fetch('/routing/reorder_drops', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${sessionToken}` },
            body: JSON.stringify({ reorder_list: reorderList }),
        });
        const body = await response.json();
        return { status: response.status, data: body };
    } catch (err) {
        logger.error("Error reordering drops:", err);
        return { status: 500, data: null };
    }
};
